import { Tab, Tabs } from 'apollo-react';
import React, { useState } from 'react';

import ActorsTable from './ActorsTable';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import {
  EXCLUDED_ACTORS_TABLE_KEY,
  INCLUDED_ACTORS_TABLE_KEY,
  TAB_EXCLUDE_USERS_INDEX,
  TAB_INCLUDE_USER_INDEX,
} from '../../constants/export.constants';

export const IMPORT_STEPS = {
  START_EXPORT: 0,
  PREVIEW: 1,
  EXPORT_PROCESSING: 2,
  EXPORT_COMPLETED: 3,
};

const IncludeUserTab = ({
  rows = [],
  handleAddActor,
  handleSelectActor,
  handleDeleteActor,
  isAddDisabled,
}) => (
  <ActorsTable
    actorsTableKey={INCLUDED_ACTORS_TABLE_KEY}
    rows={rows}
    handleAddActor={handleAddActor}
    handleSelectActor={handleSelectActor}
    handleDeleteActor={handleDeleteActor}
    isAddDisabled={isAddDisabled}
  />
);

const ExcludeUsersTab = ({
  rows = [],
  handleAddActor,
  handleSelectActor,
  handleDeleteActor,
  isAddDisabled,
}) => (
  <ActorsTable
    actorsTableKey={EXCLUDED_ACTORS_TABLE_KEY}
    rows={rows}
    handleAddActor={handleAddActor}
    handleSelectActor={handleSelectActor}
    handleDeleteActor={handleDeleteActor}
    multiSelect
    isAddDisabled={isAddDisabled}
  />
);

const IncludeExcludeUsers = ({
  exportData,
  handleAddActor,
  handleSelectActor,
  handleDeleteActor,
}) => {
  const translateString = useTranslation();

  const [selectedTab, setSelectedTab] = useState(0);

  const handleChangeTab = (e, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <Tabs value={selectedTab} onChange={handleChangeTab} truncate>
        <Tab label={translateString('Included User')} />
        <Tab label={translateString('Excluded Users')} />
      </Tabs>
      <div>
        {selectedTab === TAB_INCLUDE_USER_INDEX && (
          <IncludeUserTab
            rows={exportData[INCLUDED_ACTORS_TABLE_KEY]}
            handleAddActor={handleAddActor}
            handleSelectActor={handleSelectActor}
            handleDeleteActor={handleDeleteActor}
            isAddDisabled={exportData[EXCLUDED_ACTORS_TABLE_KEY].length}
          />
        )}
        {selectedTab === TAB_EXCLUDE_USERS_INDEX && (
          <ExcludeUsersTab
            rows={exportData[EXCLUDED_ACTORS_TABLE_KEY]}
            handleAddActor={handleAddActor}
            handleSelectActor={handleSelectActor}
            handleDeleteActor={handleDeleteActor}
            isAddDisabled={exportData[INCLUDED_ACTORS_TABLE_KEY].length}
          />
        )}
      </div>
    </>
  );
};
export default IncludeExcludeUsers;
